import { VALIDATION_PATTERNS } from '../constants';

export const isValidRedeemCode = (code) => {
  return VALIDATION_PATTERNS.REDEEM_CODE.test(code);
};

export const processRedeemCode = (code) => {
  if (!code) return '';
  
  let processedCode = code.trim().toUpperCase();
  
  if (processedCode.includes('?card=')) {
    const match = processedCode.match(/[?&]card=([A-Za-z0-9]+)/);
    if (match) {
      processedCode = match[1].toUpperCase();
    }
  }
  
  return processedCode;
};

export const extractTokenFromInput = (input) => {
  if (!input) {
    return { type: '', value: '', email: null };
  }

  const cleanInput = input.trim();
  let tokenValue = '';
  let email = null;

  if (cleanInput.includes('----')) {
    const lastPart = cleanInput.split('----').pop().trim();
    if (lastPart.startsWith('{')) {
      try {
        const jsonData = JSON.parse(lastPart);
        tokenValue = jsonData.accessToken || '';
        email = jsonData.email || jsonData.user?.email || null;
      } catch (e) {
        tokenValue = lastPart;
      }
    } else {
      tokenValue = lastPart;
    }
  } else if (cleanInput.startsWith('{')) {
    try {
      const jsonData = JSON.parse(cleanInput);
      tokenValue = jsonData.accessToken || '';
      email = jsonData.email || jsonData.user?.email || null;
    } catch (e) {
      console.error("Can't parse JSON", e);
    }
  } else {
    tokenValue = cleanInput;
  }

  let tokenType = '';
  if (tokenValue.startsWith('rt_') || tokenValue.startsWith('xyhelpertoken')) {
    tokenType = '刷新令牌';
  } else if (tokenValue.length === 45 || tokenValue.length === 44) {
    tokenType = '刷新令牌';
  } else if (tokenValue.length > 500 || tokenValue.startsWith('eyJ')) {
    tokenType = '访问令牌';
  } else {
    tokenType = '未知类型';
  }

  return { type: tokenType, value: tokenValue, email };
};

export const formatTime = (timeString) => {
  try {
    return new Date(timeString).toLocaleString('zh-CN');
  } catch {
    return timeString;
  }
};